import HighlightKey from '~/constants/common/highlightKey';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useGetKBBPromoAmount() {
  const { price = 0, kbbValue = 0, highlights } = useGetVehicleDetails();

  const hasGreatDealHighlight = highlights?.some(
    ({ tagKey }) => tagKey === HighlightKey.GreatDeal
  );
  const kbbValueIsGreaterThan0 = kbbValue > 0;
  const kbbValuePriceDifference = kbbValue - price;
  const priceDifferenceAtLeast1500 = kbbValuePriceDifference >= 1500;
  const shouldShowPromo =
    price > 0 &&
    kbbValueIsGreaterThan0 &&
    priceDifferenceAtLeast1500 &&
    hasGreatDealHighlight;

  return shouldShowPromo ? kbbValuePriceDifference : 0;
}
